/**
 * AuthCard — shared chrome for the public auth pages
 * (/login, /forgot-password, /reset-password).
 *
 * Uses the same paznetworks.com-aligned frame as the landing page
 * (dark navy header, cool-gray canvas) with a centered white card.
 */
import type { ReactNode } from 'react';
import { PublicSiteFrame } from './PublicSiteFrame';

export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <PublicSiteFrame showSignIn={false}>
      <div className="public-auth-stage">
        <div className="public-auth-card">
          <p className="public-eyebrow" style={{ marginBottom: '1.25rem' }}>
            <span className="public-eyebrow-rule" aria-hidden />
            Customer portal
          </p>
          <div>{children}</div>
        </div>
      </div>
    </PublicSiteFrame>
  );
}
